import { ABP } from '@abp/ng.core'


export namespace TerminalLog {
    export interface State {
        logs: TerminalLogReponse;
    }

    export type TerminalLogReponse = ABP.PagedResponse<TerminalLogItem>;

    export interface TerminalLogItem {
        terminalId: string;
        machineCode: string;
        information: string;
        userId: string;
        terminalLogType: 0;
        writeTime: Date;
        isDeleted: boolean;
        deleterId: string;
        deletionTime: Date;
        lastModificationTime: Date;
        lastModifierId: string;
        creationTime: Date;
        creatorId: string;
        id: string
    }

    export interface TerminalLogListRequest extends ABP.PageQueryParams {
        machineCode: string;
        writeTimeBegin: Date;
        writeTimeEnd: Date;
        terminalLogType: TerminalLogTypes;
        userName: string;
    }

    export enum TerminalLogTypes {
        Operate = 0,
        Exception = 1
    }
}
